import { render, staticRenderFns } from "./EiPersonDetail.vue?vue&type=template&id=491b6b84&scoped=true&"
import script from "./EiPersonDetail.vue?vue&type=script&lang=js&"
export * from "./EiPersonDetail.vue?vue&type=script&lang=js&"
import style0 from "./EiPersonDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EiPersonDetail.vue?vue&type=style&index=1&id=491b6b84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491b6b84",
  null
  
)

export default component.exports